import { ApiActionTypes, buildApiTypeAction } from "src/common/apiLoader/apiLoaderUtils";

export const UPDATE_CURRENT_QUOTATION = 'UPDATE_CURRENT_QUOTATION';
export const CLEAN_CURRENT_QUOTATION = 'CLEAN_CURRENT_QUOTATION';
export const CLEAN_QUOTATION_FILE = 'CLEAN_QUOTATION_FILE';

const GET_QUOTATION_FILE = 'GET_QUOTATION_FILE';
export const GET_QUOTATION_FILE_API = buildApiTypeAction(GET_QUOTATION_FILE, ApiActionTypes.REQUEST)
export const GET_QUOTATION_FILE_API_SUCCESS = buildApiTypeAction(GET_QUOTATION_FILE, ApiActionTypes.SUCCESS)
export const GET_QUOTATION_FILE_API_ERROR = buildApiTypeAction(GET_QUOTATION_FILE, ApiActionTypes.ERROR)

const UPSERT_QUOTATION = 'UPSERT_QUOTATION';
export const UPSERT_QUOTATION_API = buildApiTypeAction(UPSERT_QUOTATION, ApiActionTypes.REQUEST)
export const UPSERT_QUOTATION_API_SUCCESS = buildApiTypeAction(UPSERT_QUOTATION, ApiActionTypes.SUCCESS)
export const UPSERT_QUOTATION_API_ERROR = buildApiTypeAction(UPSERT_QUOTATION, ApiActionTypes.ERROR)

const GET_QUOTATIONS = 'GET_QUOTATIONS';
export const GET_QUOTATIONS_API = buildApiTypeAction(GET_QUOTATIONS, ApiActionTypes.REQUEST)
export const GET_QUOTATIONS_API_SUCCESS = buildApiTypeAction(GET_QUOTATIONS, ApiActionTypes.SUCCESS)
export const GET_QUOTATIONS_API_ERROR = buildApiTypeAction(GET_QUOTATIONS, ApiActionTypes.ERROR)

const GET_QUOTATION_BY_ID = 'GET_QUOTATION_BY_ID';
export const GET_QUOTATION_BY_ID_API = buildApiTypeAction(GET_QUOTATION_BY_ID, ApiActionTypes.REQUEST)
export const GET_QUOTATION_BY_ID_API_SUCCESS = buildApiTypeAction(GET_QUOTATION_BY_ID, ApiActionTypes.SUCCESS)
export const GET_QUOTATION_BY_ID_API_ERROR = buildApiTypeAction(GET_QUOTATION_BY_ID, ApiActionTypes.ERROR)

const GET_QUOTATION_TEMPLATES = 'GET_QUOTATION_TEMPLATES';
export const GET_QUOTATION_TEMPLATES_API = buildApiTypeAction(GET_QUOTATION_TEMPLATES, ApiActionTypes.REQUEST)
export const GET_QUOTATION_TEMPLATES_API_SUCCESS = buildApiTypeAction(GET_QUOTATION_TEMPLATES, ApiActionTypes.SUCCESS)
export const GET_QUOTATION_TEMPLATES_API_ERROR = buildApiTypeAction(GET_QUOTATION_TEMPLATES, ApiActionTypes.ERROR)

const UPSERT_QUOTATION_TEMPLATE = 'UPSERT_QUOTATION_TEMPLATE';
export const UPSERT_QUOTATION_TEMPLATE_API = buildApiTypeAction(UPSERT_QUOTATION_TEMPLATE, ApiActionTypes.REQUEST)
export const UPSERT_QUOTATION_TEMPLATE_API_SUCCESS = buildApiTypeAction(UPSERT_QUOTATION_TEMPLATE, ApiActionTypes.SUCCESS)
export const UPSERT_QUOTATION_TEMPLATE_API_ERROR = buildApiTypeAction(UPSERT_QUOTATION_TEMPLATE, ApiActionTypes.ERROR)

const GENERATE_QUOTATION_PDF = 'GENERATE_QUOTATION_PDF';
export const GENERATE_QUOTATION_PDF_API = buildApiTypeAction(GENERATE_QUOTATION_PDF, ApiActionTypes.REQUEST)
export const GENERATE_QUOTATION_PDF_API_SUCCESS = buildApiTypeAction(GENERATE_QUOTATION_PDF, ApiActionTypes.SUCCESS)
export const GENERATE_QUOTATION_PDF_API_ERROR = buildApiTypeAction(GENERATE_QUOTATION_PDF, ApiActionTypes.ERROR)

const SEND_QUOTATION = 'SEND_QUOTATION';
export const SEND_QUOTATION_API = buildApiTypeAction(SEND_QUOTATION, ApiActionTypes.REQUEST)
export const SEND_QUOTATION_API_SUCCESS = buildApiTypeAction(SEND_QUOTATION, ApiActionTypes.SUCCESS)
export const SEND_QUOTATION_API_ERROR = buildApiTypeAction(SEND_QUOTATION, ApiActionTypes.ERROR)

const UPDATE_QUOTATION_STATUS = 'UPDATE_QUOTATION_STATUS';
export const UPDATE_QUOTATION_STATUS_API = buildApiTypeAction(UPDATE_QUOTATION_STATUS, ApiActionTypes.REQUEST)
export const UPDATE_QUOTATION_STATUS_API_SUCCESS = buildApiTypeAction(UPDATE_QUOTATION_STATUS, ApiActionTypes.SUCCESS)
export const UPDATE_QUOTATION_STATUS_API_ERROR = buildApiTypeAction(UPDATE_QUOTATION_STATUS, ApiActionTypes.ERROR)
